export const getValidSensorPointCoordinate = (sensor) => {
  const geometry = sensor?.geometry;

  if (geometry?.type !== "Point") return null;
  if (!Array.isArray(geometry.coordinates) || geometry.coordinates.length !== 2) {
    return null;
  }

  const [longitude, latitude] = geometry.coordinates;
  if (
    typeof longitude !== "number" ||
    typeof latitude !== "number" ||
    !Number.isFinite(longitude) ||
    !Number.isFinite(latitude) ||
    longitude < -180 ||
    longitude > 180 ||
    latitude < -90 ||
    latitude > 90
  ) {
    return null;
  }

  return [longitude, latitude];
};
